import { listCatalog } from "../useLearning";
import { CATALOG_SOURCE, CATALOG_STATE, PAGE_SIZE } from "./catalogText";
import usePagedList from "./usePagedList";

export const EMPTY_FILTERS = Object.freeze({ product: "", category: "", problem: "", keyword: "", symptom: "", state: CATALOG_STATE.LEARNED });
const TEXT_KEYS = Object.freeze(["problem", "keyword", "symptom"]);
// a category slug is only unique within its product: choosing another product clears it
const RESETS = Object.freeze({ product: { category: "" } });
const NO_ITEMS = Object.freeze([]);

const loadPage = (query, signal) => listCatalog({ source: CATALOG_SOURCE.MANUAL, ...query }, { signal });

/**
 * The Manual view's data, one server page at a time (newest first, PAGE_SIZE per page): {filters, setFilter, clearFilters,
 * status, items, total, offset, setOffset, error, refresh}. Text filters wait FILTER_DEBOUNCE_MS before they query; product,
 * category and state query at once. The product -> category dropdowns are the page's (useCatalogOptions), shared with the
 * other view. See usePagedList for loading, cancelling and the not-connected states.
 */
export default function useCatalog({ enabled = true } = {}) {
  const list = usePagedList({ enabled, empty: EMPTY_FILTERS, textKeys: TEXT_KEYS, resets: RESETS, limit: PAGE_SIZE, load: loadPage });
  const { data, status, error, filters, setFilter, clearFilters, offset, setOffset, refresh } = list;
  return {
    status, error, filters, setFilter, clearFilters, offset, setOffset, refresh,
    items: (data && data.items) || NO_ITEMS,
    total: (data && data.total) || 0,
  };
}
